import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_moduleTitle = _resolveComponent("moduleTitle");
  return _openBlock(), _createElementBlock("div", {
    class: "modulecard",
    style: _normalizeStyle({
      'background': $setup.color[$setup.props.gradient]
    })
  }, [$setup.props.title ? (_openBlock(), _createBlock(_component_moduleTitle, {
    key: 0,
    text: $setup.props.title
  }, {
    default: _withCtx(() => [_renderSlot(_ctx.$slots, "rightTitle", {}, undefined, true)]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["text"])) : _createCommentVNode("v-if", true), _renderSlot(_ctx.$slots, "default", {}, undefined, true)], 4 /* STYLE */);
}